import { differenceInCalendarMonthsUTC } from "~/utils/datetime"
import { formatName } from "~/utils/namingUtils"

export type InventoryTurnPeriod = {
  monthsOfHistory: number
  isPartial: boolean
  periodLabel: string
}

// Single source of truth for the lookback-period label shown by both the
// inventory-turn and GMROI hover cards. Keeping this in one place guarantees
// the two surfaces never disagree on what "last N months" means.
export function getInventoryTurnPeriod(
  startDate: Date | string | null | undefined,
  now: Date = new Date(),
): InventoryTurnPeriod {
  if (startDate == null) {
    return { monthsOfHistory: 12, isPartial: false, periodLabel: "last 12 months" }
  }
  const start = startDate instanceof Date ? startDate : new Date(startDate)
  const monthsOfHistory = Math.min(12, Math.max(1, differenceInCalendarMonthsUTC(now, start)))
  const isPartial = monthsOfHistory < 12
  return {
    monthsOfHistory,
    isPartial,
    periodLabel: isPartial ? `last ${monthsOfHistory}mo` : "last 12 months",
  }
}

/** Spells out a lookback that fell short of the full year. Undefined when the year is complete. */
export function partialPeriodNote({ monthsOfHistory, isPartial }: InventoryTurnPeriod) {
  if (!isPartial) return undefined
  const months = monthsOfHistory === 1 ? "month" : "months"
  return `Less than 12 months of ${formatName("sale", true)} history. Calculated over ${monthsOfHistory} ${months} since first ${formatName("sale")}.`
}
